// extracted by mini-css-extract-plugin
module.exports = {"icon":"Banner-module__icon___edU0g","icon--no-title":"Banner-module__icon--no-title___wazo4","text":"Banner-module__text___Rd7mW","title":"Banner-module__title___ZgUJh"};